import { render, staticRenderFns } from "./IntegrationProperties.vue?vue&type=template&id=6a6fb56b&scoped=true&"
import script from "./IntegrationProperties.vue?vue&type=script&lang=js&"
export * from "./IntegrationProperties.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationProperties.vue?vue&type=style&index=0&id=6a6fb56b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fb56b",
  null
  
)

export default component.exports